import { IconButton, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import React from 'react';

export const CardTitle = ({ children }: { children: React.ReactNode }) => {
  const theme = useTheme();
  return (
    <Typography
      justifyContent="space-between"
      alignItems="center"
      sx={{ display: 'flex', borderBottom: `1px solid ${theme.palette.grey[300]}` }}
      padding={'8px 16px'}
      variant="subtitle1">
      {children}
    </Typography>
  );
};

export const CardBody = styled('div')`
  height: 300px;
  overflow: auto;
`;

export const CardBodyGroup = styled('div')`
  margin: 8px 16px;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.palette.text.secondary};
`;

export const CardBodyBold = styled('div')`
  font-weight: bold;
`;

export const BubbleTitle = styled('div')`
  background-color: ${(props) => props.theme.palette.grey[100]};
  display: inline-block;
  line-height: 20px;
  border-radius: 16px;
  padding: 0 8px;
  margin-bottom: 4px;
  font-size: 14px;
  font-weight: bold;
`;

export const CardText = styled('div')`
  font-size: 13px;
  line-height: 15px;
`;

export const CollapseDetailsButton = styled(IconButton)`
  position: absolute;
  left: 50%;
  bottom: -15px; // For a 48px button, this centers it on the edge
  transform: translateX(-50%);
  z-index: 100;
  border: 1.5px solid #4caf50;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  margin: 0;
  padding: 0;
  width: 30px;
  height: 30px;

  &:hover {
    background-color: #f5f5f5;
  }
`;
